"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findNodeContainingDataHook = exports.findComponentByDataHook = exports.findElementByDataHook = void 0;
var findElementByDataHook = function (component) { return function (dataHook) {
    return component.find("[data-hook=\"".concat(dataHook, "\"]"));
}; };
exports.findElementByDataHook = findElementByDataHook;
/*
TODO
src/helpers/test-driver-base.ts:5:14 - error TS2742: The inferred type of 'findComponentByDataHook' cannot be named without a reference to 'enzyme/node_modules/@types/react'. This is likely not portable. A type annotation is necessary.

5 export const findComponentByDataHook = (component: ReactWrapper) =>
*/
var findComponentByDataHook = function (component) { return function (dataHook) {
    return component.findWhere(function (child) {
        // Read more: https://github.com/airbnb/enzyme/issues/1228
        if (!child.exists()) {
            return;
        }
        return child.prop('dataHook') === dataHook;
    });
}; };
exports.findComponentByDataHook = findComponentByDataHook;
var findNodeContainingDataHook = function (component) { return function (dataHook) {
    return component.findWhere(function (node) {
        // Read more: https://github.com/airbnb/enzyme/issues/1228
        if (!node.exists()) {
            return;
        }
        var hook = node.prop('data-hook');
        return hook && hook.indexOf(dataHook) >= 0;
    });
}; };
exports.findNodeContainingDataHook = findNodeContainingDataHook;
var TestDriverBase = /** @class */ (function () {
    function TestDriverBase(component) {
        this.store = null;
        this.component = component;
    }
    TestDriverBase.prototype.getComponent = function () {
        return this.component;
    };
    TestDriverBase.prototype.update = function (ms) {
        var _this = this;
        if (ms === void 0) { ms = 50; }
        return this._wait(ms).then(function () { return _this.component.update(); });
    };
    // NOTE: this method can be used in cases when setTimeout or setInterval overridden with jest.useFakeTimers(),
    // it will still run update asynchronously, even if setTimeout is sync
    TestDriverBase.prototype.nextTickUpdate = function () {
        var _this = this;
        return Promise.resolve().then(function () { return _this.component.update(); });
    };
    TestDriverBase.prototype.findComponentByDataHook = function (dataHook) {
        return (0, exports.findComponentByDataHook)(this.getComponent())(dataHook);
    };
    TestDriverBase.prototype.findElementByDataHook = function (dataHook) {
        return (0, exports.findElementByDataHook)(this.getComponent())(dataHook);
    };
    TestDriverBase.prototype.findNodeContainingDataHook = function (dataHook) {
        return (0, exports.findNodeContainingDataHook)(this.getComponent())(dataHook);
    };
    TestDriverBase.prototype._clickWrapper = function (reactWrapper) {
        reactWrapper.simulate('click');
        return this;
    };
    TestDriverBase.prototype._wait = function (ms) {
        return new Promise(function (res) {
            setTimeout(res, ms);
        });
    };
    return TestDriverBase;
}());
exports.default = TestDriverBase;
//# sourceMappingURL=test-driver-base.js.map